import recommend from '@algolia/recommend'
import { useRecommendations } from '@algolia/recommend-react'

const recommendClient = recommend(
  process.env.GATSBY_ALGOLIA_ID,
  process.env.GATSBY_ALGOLIA_KEY
)
const indexName = process.env.GATSBY_ALGOLIA_INDEX_LUX_ONLY_NAME

const useAlgoliaRecommend = (
  objectIds,
  maxRecommendations = 10,
  filters = ''
) => {
  const { recommendations } = useRecommendations({
    model: 'related-products',
    recommendClient,
    indexName,
    objectIDs: objectIds,
    maxRecommendations,
    queryParameters: { filters }
  })

  return {
    recommendations
  }
}

export default useAlgoliaRecommend
